module.exports = __webpack_public_path__ + "static/media/02.31acac06.jpg";